module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hant/5-e382726373bcc31eafae34ff2373ee2d.jpg";